import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Box, CircularProgress, Typography, Alert } from '@mui/material';
import { useAuth } from '../../hooks/useAuth';
import api from '../../services/api';

const SsoCallback: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { login } = useAuth();
  const [error, setError] = useState('');

  useEffect(() => {
    const token = searchParams.get('token');

    if (!token) {
      setError('No authentication token received from SSO provider.');
      setTimeout(() => navigate('/login?error=no_token', { replace: true }), 3000);
      return;
    }

    // Use the token to fetch user profile and complete login
    const completeLogin = async () => {
      try {
        const response = await api.get('/auth/profile', {
          headers: { Authorization: `Bearer ${token}` },
        });
        login(token, response.data);

        const dest =
          response.data.role === 'admin'
            ? '/admin'
            : response.data.role === 'instructor'
            ? '/instructor'
            : '/student';
        navigate(dest, { replace: true });
      } catch {
        setError('Failed to complete SSO login. Please try again.');
        setTimeout(() => navigate('/login?error=sso_failed', { replace: true }), 3000);
      }
    };

    completeLogin();
  }, [searchParams, login, navigate]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        bgcolor: '#0a0a14',
      }}
    >
      {error ? (
        <Alert severity="error" sx={{ maxWidth: 400 }}>
          {error}
        </Alert>
      ) : (
        <>
          <CircularProgress size={48} sx={{ mb: 3 }} />
          <Typography variant="h6" color="rgba(255,255,255,0.7)">
            Completing SSO login...
          </Typography>
        </>
      )}
    </Box>
  );
};

export default SsoCallback;
